module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("For Micky Perry, ")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("who qualifies for the following job descriptions:")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("Excellent Wife")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("Patient and Affectionate Editor ")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("(experienced and qualified)")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("Beacon of Faith ")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("(patience a plus)")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('i')]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("She’s hired. ")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("Position is permanent, ")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('i', [_vm._v("retirement plan included.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('i')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-238f345f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section2.vue
// module id = 69
// module chunks = 0